<template>
    <div class="infomacchina">
        <b-tabs content-class="mt-3" @input="tabChanged">
            <b-tab :title="machine.codice" active>
                <b-row v-if="!is3Davailable">
                    <b-col cols="5" class="schede">
                        <div class="scheda">
                            <SchedaMacchina :m="machine" :info="false" />
                        </div>
                    </b-col>
                    <b-col cols="4" class="schede">
                        <b-card title="Total assistance hours" class="tahpc h90">
                            <div class="chart">
                                <TotalAssistanceHoursPieChart
                                    :width="350"
                                    :height="250"
                                    :mcode="machine.codice"
                                    field="type"
                                    class="patch"
                                />
                            </div>
                        </b-card>
                    </b-col>
                    <b-col cols="3">
                        <b-card class="h90 contacts">
                            <ContactUs />
                        </b-card>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="scrollami" v-if="!is3Davailable">
                        <b-card class="components">
                            <ShowComponents :m="machine"/>
                        </b-card>
                    </b-col>
                    <b-col class="scrollami scrollami3D" v-else>
                        <b-card class="components">
                            <ShowComponents3D :m="machine" :name3D="name3D" />
                        </b-card>
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab title="Assistance and Analytics">
                <b-card class="assistance">
                    <Assistance :m="machine" :asComp="true" :key="currTab" :tblHeight="330" :anaHeight="292" />
                </b-card>
            </b-tab>
            <b-tab title="Documentation">
                <ShowDocuments :m="machine" />
            </b-tab>
            <b-tab title="Backup">
                <ShowBackups :m="machine" />
            </b-tab>
        </b-tabs>
    </div>
</template>
<script>
import SchedaMacchina from "@/components/SchedaMacchina.vue";
import ShowComponents from "@/components/ShowComponents.vue";
import ShowComponents3D from "@/components/ShowComponents3D.vue";
import ShowBackups from "@/components/ShowBackups.vue";
import ShowDocuments from "@/components/ShowDocuments.vue";
import Assistance from "@/views/Assistance.vue";

import TotalAssistanceHoursPieChart from "@/components/TotalAssistanceHoursPieChart.vue";
import ContactUs from "@/components/ContactUs.vue";
import { API } from "@/api.js";

export default {
    name: "InfoMacchina",
    data() {
        return {
            lastBackup: null,
            fields: [
                { key: "code", sortable: true, class: "font-weight-bold" },
                { key: "title", sortable: true },
                { key: "date", sortable: true, formatter: "dateFormatter" },
            ],
            tickets: [],
			currTab: -1,
            is3Davailable: false,
            name3D: null,
        };
    },
    components: {
        SchedaMacchina,
        ShowComponents,
        ShowComponents3D,
        TotalAssistanceHoursPieChart,
        ContactUs,
        ShowDocuments,
        ShowBackups,
        Assistance
    },
    computed: {
        machine() {
            console.log("machine", this.$store.getters.machine);
            return this.$store.getters.machine;
        },
    },
    async mounted() {
        let data = await API.getBackups(this.machine.codice);
        // console.log("data", data, this.machine.codice);
        if (data && data.length) this.lastBackup = data.pop();

        let tickets = await API.lastTickets(7, this.machine.codice);
        this.tickets = tickets.map((t) => ({
            code: t.unit_code,
            title: t.title,
            date: new Date(t.opendate),
        }));
        this.is3Davailable = await API.get3Davailable(this.machine.codice);
        console.log("is3Davailable", this.is3Davailable);
        if( this.is3Davailable) {
            this.name3D = await API.get3Dname(this.machine.codice);
            console.log("name3D", this.name3D);
        }
		this.$nextTick(async () => {
            this.machine.image = "/images/units/" + this.machine.img;
		});
    },
    methods: {
        dateFormatter(value) {
            return value.toLocaleDateString();
        },
        tabChanged(index) {
            this.currTab = index;
        },
    },
};
</script>
<style scoped>
.assistance {
    max-height: calc(100vh - 184px);
}
div.h90 {
    height: 90%;
}
div.h90.contacts {
    position: relative;
    right: 15px;    
    overflow: hidden;
    margin-right: 0;
}
div.h90.contacts div.card-body{
    background-color: #6b1106;
    border: inherit;
}
div.scrollami {
    overflow: auto;
    max-height: calc(100vh - 460px);
    max-width: 99%;
}
div.scrollami.scrollami3D {
    max-height: calc(100vh - 250px);
}
div.infomacchina div.tahpc h4 {
    position: relative;
    left: 80px;
}
#showcomps {
    max-height: 100%;
    height: 100%;}
.components {
    /* max-height: calc(100vh - 400px);
    height: calc(100vh - 400px); */
}
div.card {
    margin: 10px;
}
div.infomacchina {
    background-color: lightgrey;
    overflow: hidden;
    height: calc(100vh - 180px);
    max-height: calc(100vh - 180px);
}
.scheda {
    height: 100%;
    max-height: 100%;
    min-height: 100%;
}
div.chart {
    max-height: 100px;
    min-height: 100px;
    height: 200px;
    width: 300px;
}
.patch {
    position: relative;
    top: -65px;
    left: 70px;
}
.dot {
    height: 50px;
    width: 50px;
    background-color: #47c346;
    border-radius: 50%;
    display: inline-block;
    position: relative;
    top: 23px;
    left: 27px;
}
</style>
